import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function getHash() {
    let hash = location.hash.slice(1).split("#"),
        output = {};
    for (let i = 0; hash[i]; i++) {
        let j = hash[i].split("=");
        output[j[0]] = j[1];
    }
    return output;
}
export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        this.setLoad();
        this.scrollIn();
        this.initPagination();
    }

    setLoad() {
        window.addEventListener("load", () => {
            document.body.classList.add("-load");
        });
    }

    scrollIn() {
        const revealElm = document.querySelectorAll(".js-scrollreveal");

        revealElm.forEach((el) => {
            const startPos = el.dataset.start || "top 80%";
            ScrollTrigger.create({
                trigger: el,
                start: startPos,
                onEnter: (self) => {
                    el.classList.add("-reveal");
                },
            });
        });
    }

    initPagination() {
        this.article = document.querySelector(".js-article");
        if (!this.article) return;

        this.articleMain = document.querySelector(".js-article-main");
        this.articleParts = document.querySelectorAll(".js-article-part");
        this.currentPart = Number(getHash().part) || 1;
        this.isInitialPageIn = true;

        this.updatePart();
        this.bindPartEvents();

        window.addEventListener("hashchange", () => {
            const part = Number(getHash().part) || 1;
            if (part === this.currentPart) return;
            this.currentPart = part;
            this.isInitialPageIn = false;
            this.updatePart();
            this.scrollToArticle();
        });
    }

    updatePart() {
        this.articleMain.dataset.part = this.currentPart;
        this.articleMain.dataset.pageinDelay = this.isInitialPageIn ? "initial" : "paginate";
        this.articleMain.dataset.pagein = "out";
        setTimeout(() => {
            this.articleMain.dataset.pagein = "in";
        }, 100);

        //PREV
        document.querySelectorAll(".js-article-prev-part").forEach((btn) => {
            if (this.currentPart > 1) {
                btn.setAttribute("href", `./#part=${this.currentPart - 1}`);
                btn.classList.remove("-disabled");
            } else {
                btn.classList.add("-disabled");
            }
        });

        //NEXT
        document.querySelectorAll(".js-article-next-part").forEach((btn) => {
            if (this.currentPart < this.articleParts.length) {
                btn.setAttribute("href", `./#part=${this.currentPart + 1}`);
                btn.classList.remove("-disabled");
            } else {
                btn.classList.add("-disabled");
            }
        });

        this.updatePager();
    }

    updatePager() {
        const total = this.articleParts.length;
        const current = this.currentPart;
        const pages = this.generatePageNumbers(current, total);

        let html = "";
        pages.forEach((page) => {
            if (page === "ellipsis") {
                html += `<li class ="novel__story__pager__ellipsis">...</li>`;
            } else {
                const activeClass = page === current ? "-active" : "";
                html += `<li class ="novel__story__pager__item c-hover_op js-article-pager-item ${activeClass}" data-page="${page}">
                    <a href="./#part=${page}">${page}</a>
                </li>`;
            }
        });
        const list = document.querySelector(".js-article-pager-list");
        if (list) list.innerHTML = html;
    }

    generatePageNumbers(current, total) {
        if (total <= 6) {
            return Array.from({ length: total }, (_, i) => i + 1);
        }
        if (current <= 4) {
            return [1, 2, 3, 4, 5, "ellipsis", total];
        }
        if (current >= total - 3) {
            return [1, "ellipsis", total - 4, total - 3, total - 2, total - 1, total];
        }
        return [1, "ellipsis", current - 1, current, current + 1, "ellipsis", total];
    }

    bindPartEvents() {
        document.querySelectorAll(".js-article-prev-part").forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                if (this.currentPart > 1) location.hash = `part=${this.currentPart - 1}`;
            });
        });

        document.querySelectorAll(".js-article-next-part").forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                if (this.currentPart < this.articleParts.length) {
                    location.hash = `part=${this.currentPart + 1}`;
                }
            });
        });

        const pagerList = document.querySelector(".js-article-pager-list");
        if (pagerList) {
            pagerList.addEventListener("click", (e) => {
                const li = e.target.closest(".js-article-pager-item");
                if (!li) return;
                e.preventDefault();
                const page = Number(li.dataset.page);
                if (page) location.hash = `part=${page}`;
            });
        }
    }

    scrollToArticle() {
        window.scrollTo({ top: 0, behavior: "auto" });
    }
}
